import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

const ContextRoute = ({ contextProvider, component, ...rest }) => {
  const Provider = contextProvider;
  const Component = component;

  return (
    <Route {...rest}>
      <Provider>
        <Component />
      </Provider>
    </Route>
  );
};

ContextRoute.propTypes = {
  contextProvider: PropTypes.node,
  component: PropTypes.node,
};

export default ContextRoute;
